//console.log("testJS");
if (sa_wl_app == undefined) {
    var sa_wl_app = true;
    var jQueryScriptOutputted = false;
    function initJQuery() {
        //console.log(typeof jQuery())
        sp_included = true;  
        if (typeof (jQuery) == 'undefined') {  
            
            if (!jQueryScriptOutputted) { 
                jQueryScriptOutputted = true;
                var head = document.getElementsByTagName("head")[0];
                var js = document.createElement("script");
                js.type = "text/javascript";
                js.src = "//ajax.googleapis.com/ajax/libs/jquery/1.8.2/jquery.min.js";
                head.appendChild(js);
            }
            //debugger;
            setTimeout("initJQuery()", 50);

        } else {
			
            var ajaxManager = {
                requests: [],
                addReq: function (opt) {
                    this.requests.push(opt);

                    if (this.requests.length == 1) {
                        this.run();
                    }
                },
                removeReq: function (opt) {
                    if ($.inArray(opt, requests) > -1)
                        this.requests.splice($.inArray(opt, requests), 1);
                },
                run: function () {
                    // original complete callback
                    oricomplete = this.requests[0].complete;

                    // override complete callback
                    var ajxmgr = this;
                    ajxmgr.requests[0].complete = function () {
                        if (typeof oricomplete === 'function')
                            oricomplete();

                        ajxmgr.requests.shift();
                        if (ajxmgr.requests.length > 0) {
                            ajxmgr.run();
                        }
                    };

                    $.ajax(this.requests[0]);
                },
                stop: function () {
                    this.requests = [];
                }
            }

            var sw_enable_popup;
            $.ajax({
                url: "https://shopiapps.in/wishlistapp/wishlist_login.php?shop=" + Shopify.shop,
                type: 'GET',
                dataType: 'html',
                success: function (data, textStatus, jqXHR) {
                    //console.log(data);
                    var html = $.parseHTML(data);
                    
                    sw_enable_popup = $(html).find("#sw_enable_popup").val();
                    if (sw_enable_popup == '1') {
                        $('body').append(data);
                    }
                }
            });

            $(document).delegate( '.notLoggedIn','click', function (evt) { 
            	if($ == undefined)
            		$ = jQuery;
            	
            	
                evt.preventDefault(); 
                var cust_id = $(this).attr('cust_id');
                if (cust_id == "") {
                    if (sw_enable_popup == '1') {
                        var $form_modal = $('.sw-user-modal'),
                        $form_login = $form_modal.find('#sw-login'),
                        $form_signup = $form_modal.find('#sw-signup'),
                        $form_forgot_password = $form_modal.find('#sw-reset-password'),
                        $form_modal_tab = $('.sw-switcher'),
                        $tab_login = $form_modal_tab.children('li').eq(0).children('a'),
                        $tab_signup = $form_modal_tab.children('li').eq(1).children('a'),
                        $forgot_password_link = $form_login.find('.sw-form-bottom-message a.sw_fpwd'),
                        $back_to_login_link = $form_forgot_password.find('.sw-form-bottom-message a'),
                        $main_nav = $('.sw-signin_link');

                        $sw_login_header = $form_modal.find("#sw_login_header");
                        $l_heading = $form_modal.find("#sw_l_heading").val();;
                        $f_heading = $form_modal.find("#sw_f_heading").val();;
                        $pwd_show_text = $form_modal.find("#sw_pwd_show_text").val();;
                        $pwd_hide_text = $form_modal.find("#sw_pwd_hide_text").val();

                        $form_login.find('#sw-signin-email').val("");
			            $form_login.find('#sw-signin-password').val("");
			            $form_signup.find('#sw-signup-firstname').val("");
			            $form_signup.find('#sw-signup-lastname').val("");
			            $form_signup.find('#sw-signup-email').val("");
			            $form_signup.find('#sw-signup-password').val("");
			            $form_forgot_password.find('#sw-reset-email').val("");
			            $form_modal.find(".sw-form-error").hide();
			            $form_modal.find(".sw-form-succ").hide();
			            $form_modal.find(".sw-form-loader").hide();
			            
			            $form_modal.addClass('is-visible');
			             
			             $sw_login_header.text($l_heading);
			            $form_modal.find("input").removeClass("has-error");
			            $form_modal.find("span.sw-error-message").removeClass("is-visible");
			            
			            $form_modal.find(".sw-form-error").hide();
			            $form_modal.find(".sw-form-succ").hide();
			            $form_login.addClass('is-selected');
			            $form_signup.removeClass('is-selected');
			            $form_forgot_password.removeClass('is-selected');
			            $tab_login.addClass('selected');
			            $tab_signup.removeClass('selected');
        
                    } else {
                        window.location = '/account/login';
                    }
                }
            });

            $(document).on('click','.addToFavorite',function (e) {

                e.preventDefault();

                if($ == undefined)
            		$ = jQuery;

                var type = $(this).attr("type");
                if (type == undefined) {
                    type = "btn";
                }
                
                var variant_id = $(this).parents("form").find("select[name='id'] option:selected").val();
                
                if (variant_id == undefined) {
                    variant_id = "";
                }
                var product_id = $(this).attr('id');
                var customer_id = $(this).attr('cust_id');
                $(this).parent().find('img').show();
                $('.overlay').show();
                var url = 'https://shopiapps.in/wishlistapp/index.php?mode=add&p_id=' + product_id + '&v_id=' + variant_id + '&c_id=' + customer_id + '&shop=' + Shopify.shop + '&_=' + new Date().getTime();
                console.log(url,'url');
                var pdata = {"type": type};
                ajaxManager.addReq({
                    url: url,
                    type: "GET",
                    data: pdata,
                    dataType: "jsonp",
                    jsonpCallback: 'callSuccess',
                    error: function (jqXHR, textStatus, errorThrown) {
                        
                    }
                });
                return false;
            });

            $(document).delegate('.removeFavorite', 'click', function (evt) {
                evt.preventDefault();
                if($ == undefined)
            		$ = jQuery;

                var variant_id = $(this).parents("form").find("select[name='id'] option:selected").val();
                
                if (variant_id == undefined) {
                    variant_id = "";
                }

                var product_id = $(this).attr('id');
                var customer_id = $(this).attr('cust_id');
                var type = $(this).attr("type");
                //$(this).next('img').show();
                $(this).parent().find('img').show();
                $('.overlay').show();
                var url = 'https://shopiapps.in/wishlistapp/index.php?mode=rem&p_id=' + product_id + '&v_id=' + variant_id + '&c_id=' + customer_id + '&shop=' + Shopify.shop + '&_=' + new Date().getTime();
                if (type == "anchor") {
                    var pdata = {"type": type};
                } else {
                    var pdata = {};
                }
                ajaxManager.addReq({
                    url: url,
                    type: "GET",
                    data: pdata,
                    dataType: "jsonp",
                    jsonpCallback: 'callSuccess',
                    success:function(data){
                        if(data.html_emty == 1){
                            $('.h_no_product').show();
                            $('#share_html').hide();
                        }

                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        
                    }
                });
            });
        }
    }

 
    if (sp_included == undefined) {  
        var sp_included = false;
        if (sp_included == false) {
            initJQuery();
        }
    }

    function callSuccess(data) {
        var id = data.id;
        
        if(Shopify.shop == 'hey-holla.myshopify.com'){
            
           $(document).find('span#wishCnt').text(': '+data.cnt);
        }
        if (data.type == "anchor") {
            if (data.prod_removed == "yes") {
              console.log(1);
                var id = data.id;
                $('.remove_' + id).parent().find('img').hide();
                $('.remove_' + id).parents('div .prd_divv').remove();
                $('.remove_' + id).parents('div.prd_divv').remove();
                var prd_divv_box = $("." + id);
                $(prd_divv_box).find('.remove_' + id).parent().find('img').hide();
                $('.overlay').hide();
                
                $(prd_divv_box).hide();
                $(prd_divv_box).remove();
                return false;
            } else if (data.already_added == 1) {
                $('.add_' + id).parent().find('img').hide();
                $('.overlay').hide();
                
                $("#" + id+', .add_'+id).html("Added to Wishlist").addClass("added").removeClass("notadded");
                alert("This product has been added to your wishlist");
                return false;
            } else {
                $('.add_' + id).parent().find('img').hide();
                $('.overlay').hide();
                $("#" + id+', .add_'+id).html("Added to Wishlist").addClass("added").removeClass("notadded");
                return false;
            }
        } else {
            if (data.success >= 0) {
              console.log(1);
                var curr_class = $('.remove_' + id).parents('div').attr('class');
                if ($('.remove_' + id).parent('div').hasClass('hearted')) {
                    var title = "Add to Wishlist";
                    if ($('#add_title_' + id).length && $('#add_title_' + id).val() != "") {
                        title = $('#add_title_' + id).val();
                    }
                    $('.remove_' + id).parent('div').addClass("nothearted").removeClass("hearted");
                    $('.remove_' + id).val(data.success).attr("title", title);
                    $('.remove_' + id).parent().find('img').hide();
                    //$('.remove_' + id).parent('div').find('span').text('Added to whislist');
                    $('.remove_' + id).addClass('addToFavorite add_' + id).removeClass('removeFavorite remove_' + id);
                    $('.add_' + id).parents('div.prd_divv').remove();
                    
                    $('.overlay').hide();
                   console.log(1);
                } else {
                  console.log(2);
                    var title = "Remove from Wishlist";
                    if ($('#remove_title_' + id).length && $('#remove_title_' + id).val() != "") {
                        title = $('#remove_title_' + id).val();
                    }
                    $('.add_' + id).parent('div').addClass("hearted").removeClass("nothearted");
                    //$('.add_' + id).parent('div').find('span').text('Add to whislist');
                    $('.add_' + id).val(data.success).attr("title", title);
                    $('.add_' + id).parent().find('img').hide();
                    $('.add_' + id).addClass('removeFavorite remove_' + id).removeClass('addToFavorite add_' + id);
                    //$('.notLoggedIn_notify').remove();
                    $('.overlay').hide();
                   console.log(2);
                }
            } else {
                $('.overlay').hide();
                $('.remove_' + id).parent().find('img').hide();
                $('.add_' + id).parent().find('img').hide();
            }
        }
        
    }

  setTimeout(function(){
        var SA_WishCSS = document.createElement("link");
        SA_WishCSS.rel = "stylesheet";
        SA_WishCSS.type = "text/css";
        SA_WishCSS.href = 'https://shopiapps.in/wishlistapp/wishlist_css.php?shop=' + Shopify.shop ;
        document.getElementsByTagName("head")[0].appendChild(SA_WishCSS);
    },500); 

 //   document.write('<link rel="stylesheet" href="https://shopiapps.in/wishlistapp/wishlist_css.php?shop=' + Shopify.shop + '" />');

}